import {
  BiDashboardLayout,
  BiLayoutItem,
  BiLayoutMode,
} from '@euler/model/bi/dashboard';
import {
  BiPresetRow,
  biPresetColumnCount,
  biPresetRows,
  biStackedCardIds,
  kBiStackedBelow,
} from './biGridLayout';

/** How a dashboard is drawn at one content width. */
export type BiPresentation =
  /** Narrow: one card per row, top to bottom, in either mode. */
  | { kind: 'stacked'; cardIds: string[] }
  | { kind: 'preset'; columnCount: 2 | 3; rows: BiPresetRow[] }
  /** The stored 12-column grid, exactly. */
  | { kind: 'custom'; items: BiLayoutItem[] };

export function biPresentation(
  layout: BiDashboardLayout,
  width: number,
): BiPresentation {
  if (width < kBiStackedBelow)
    return { kind: 'stacked', cardIds: biStackedCardIds(layout) };
  if (layout.mode === BiLayoutMode.Custom)
    return { kind: 'custom', items: layout.items };
  const columnCount = biPresetColumnCount(layout.columns, width);
  return {
    kind: 'preset',
    columnCount,
    rows: biPresetRows(layout, columnCount),
  };
}
